import { ContenidoStatus } from './../../../../../common/contenido';
import { Action } from '@ngrx/store';
import { Contenido } from 'src/common/contenido';


export enum DestacadoActionTypes {
	DestacadoPageRequested = '[Base Component] Destacado Page Requested',
	DestacadoPageLoaded = '[Destacado API] Destacado Page Loaded',
	DestacadoPageCancelled= '[Destacado API] Destacado Page Cancelled',
	DestacadoPageRight = '[Destacado API] Destacado Page Right'
}

export class DestacadoPageRequested implements Action {
	readonly type: string = DestacadoActionTypes.DestacadoPageRequested;
	constructor() {
	}
}

export class DestacadoPageLoaded implements Action {
	readonly type: string = DestacadoActionTypes.DestacadoPageLoaded;
	constructor( public payload: { cleared: boolean, status: ContenidoStatus, destacado: Contenido[] }) {
	}
}

export class DestacadoPageCancelled implements Action {
	readonly type: string = DestacadoActionTypes.DestacadoPageCancelled;
	constructor( public payload: { status: ContenidoStatus } ) {
	}
}

export class DestacadoPageRight implements Action {
	readonly type: string = DestacadoActionTypes.DestacadoPageRight;
	constructor() {
	}
}


export type DestacadoActions = DestacadoPageRequested | DestacadoPageLoaded | DestacadoPageCancelled | DestacadoPageRight;